import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Quiz from "../Components/Dashboard/Term-projects/quiz/quiz";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthQuiz = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Quiz /> : <SessionTimeoutRedirect />
}
export default AuthQuiz;


